import { Input as InputComponent, InputBase } from './Input';
import { InputGroup } from './InputGroup';

export const Input = Object.assign(InputComponent, {
    Base: InputBase,
    Group: InputGroup,
});

export type { InputBaseProps, InputProps } from './Input';
export type { InputGroupProps } from './InputGroup';
